/**
 *
 * @param {string} externalId
 * @param {string?} prefix
 * @returns {string}
 */
export const formatPropertyId = (externalId, prefix) => {
    if (!externalId) { return ''; }
    const splitIds = externalId.split(':');
    if (splitIds?.[1]) {
        return `${prefix ?? ''}${externalId.split(':')?.[1]}`;
    } else {
        // If there's no type to the string (RexListingId:) just display the whole string
        return externalId;
    }
};

export const formatCurrency = (value, currency = 'GBP') => {
    return Number(value).toLocaleString('en-GB', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};

/**
 * @param {number} monthlyRent
 * @param {string} currency
 * @param {import("$types/generated/cms-graphql.d.ts").PropertiesRentalPropertyDetailPagePriceRentPeriodChoices} [period]
 * @param {{ includeSuffix: boolean }} [opts]
 * @returns {string | undefined}
 */
export const formatRentPrice = (monthlyRent, currency, period, opts = { includeSuffix: true }) => {
    let periodMultiplier = 1;
    let suffix = '';
    switch (period) {
        case 'WEEKLY':
            periodMultiplier = 0.25;
            suffix = 'Week';
            break;
        case 'MONTHLY':
            suffix = 'Month';
            break;
        case 'ANNUALLY':
            periodMultiplier = periodMultiplier * 12;
            suffix = 'Year';
            break;
    }
    return `${formatCurrency(monthlyRent * periodMultiplier, currency)}${(suffix && opts?.includeSuffix) ? `/${suffix}`: ''}`;
};

export const formatPublicationDate = (isoString) => {
    if (!isoString) { return ''; }
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
};

/**
 * Group property modules into sections
 * @type {import("$types/components/utilities").GroupPropertyModulesStreamFn}
 */
export const groupPropertyModulesStream = (modules) => {
    if (modules.length > 0) {
        let results = [];
        let currentSection = -1;
        for (const mod of modules) {
            switch (mod.__typename) {
                // Section start
                case 'PropertyDetailSectionTextItem':
                    currentSection += 1;
                    results.push({
                        ...mod,
                        __typename: 'PropertyDetailSection',
                        images: []
                    });
                    break;
                // Section images
                case 'PropertyDetailSectionMediaItem':
                    if (results[currentSection]?.__typename === 'PropertyDetailSection') {
                        results[currentSection]?.images?.push(mod);
                    } else {
                        currentSection += 1;
                        results.push({
                            heading: '',
                            body: '',
                            __typename: 'PropertyDetailSection',
                            images: [mod]
                        });
                    }
                    break;
                // Different "sections"
                default:
                    currentSection += 1;
                    results.push(mod);
                    break;
            }
        }
        return results;
    }
};

/**
 * Format link block to url.
 * @param {object} data
 * @returns {string}
 */
export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = null;
    switch (linkTo) {
        case 'email':
            url = 'mailto:' + data[linkTo];
            break;
        case 'anchor':
            url = '#' + data[linkTo];
            break;
        case 'custom_url':
            url = data?.customUrl;
            break;
        case 'file':
            url = data[linkTo]?.url;
            break;
        case 'page':
            url = data[linkTo]?.url;
            break;
        case 'phone':
            url = 'tel:' + data[linkTo];
            break;
    }

    return url;
};
